export default "__VITE_ASSET__73bbc5f6__"